import React from 'react';


export default class PrintableHonorCard extends React.Component {
	constructor(props) {
    	super(props);
	}

	render() {
		return (
			<div className="honor-card-pdf">
				<a href={this.props.pdf} ><img src= {this.props.image}  width="250"/></a>
			</div>
		);
	}
}